import React from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { SectionLink } from './SectionLink';
import { formatNumber, formatPercent } from '../../utils/format';
import type { AgentStats } from '../../types/voip';
interface CallMixProps {
  totals: AgentStats;
  onViewAll: () => void;
}
export function CallMix({
  totals,
  onViewAll
}: CallMixProps) {
  const segments = [{
    name: 'Outbound',
    value: totals.outbound,
    color: '#00364d'
  }, {
    name: 'Inbound answered',
    value: totals.inbound,
    color: '#7fa3b9'
  }, {
    name: 'Missed',
    value: totals.missed,
    color: '#dc2626'
  }];
  const total = totals.totalCalls || 1;
  return <section aria-labelledby="call-mix-heading" className="flex h-full flex-col rounded-2xl border border-line bg-surface p-6 shadow-card" data-id="element-234" data-mp="sbt7s9stdm9u">
      <div className="mb-2 flex items-start justify-between gap-3" data-id="element-235" data-mp="23sjdzsx8me3g">
        <h2 id="call-mix-heading" className="text-base font-semibold text-ink" data-id="element-236" data-mp="1zrpq2zjsozak">
          Call mix
        </h2>
        <SectionLink label="View report" onClick={onViewAll} data-id="element-237" data-mp="1ecxnc1e8lfg9" />
      </div>
      <div className="flex flex-1 flex-col items-center gap-6 sm:flex-row" data-id="element-238" data-mp="1eeqt7eh0zvn7">
        <div className="relative h-44 w-44 shrink-0" data-id="element-239" data-mp="1j9o3eoq1kb1o">
          <ResponsiveContainer width="100%" height="100%" data-id="element-240" data-mp="1ncuhgijeb6ip">
            <PieChart data-id="element-241" data-mp="1nb9m4qp9bjjs">
              <Pie data={segments} dataKey="value" nameKey="name" innerRadius={56} outerRadius={78} paddingAngle={2} stroke="none" startAngle={90} endAngle={-270} animationDuration={300} data-id="element-242" data-mp="1sbxat5q0joau">
                {segments.map(s => <Cell key={s.name} fill={s.color} data-id="element-243" data-mp="19dutld3pivnl" />)}
              </Pie>
              <Tooltip contentStyle={{
              borderRadius: 10,
              border: '1px solid #e4e9ef',
              fontSize: 12
            }} formatter={v => formatNumber(Number(v))} data-id="element-244" data-mp="by74dsbf8ny1" />
            </PieChart>
          </ResponsiveContainer>
          <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center" data-id="element-245" data-mp="1k6d2449f1g0u">
            <span className="font-display text-[28px] font-bold leading-none text-ink" data-id="element-246" data-mp="1f8kzaf78g9hv">{formatNumber(totals.totalCalls)}</span>
            <span className="mt-1 text-xs text-muted" data-id="element-247" data-mp="1t22ly8v7u2c4">Total calls</span>
          </div>
        </div>
        <ul className="w-full space-y-3" data-id="element-248" data-mp="1p10jzk9wzc6g">
          {segments.map(s => <li key={s.name} className="flex items-center justify-between gap-3 text-sm" data-id="element-249" data-mp="119bsg64x2rqk">
              <span className="flex items-center gap-2 text-muted" data-id="element-250" data-mp="wbtjwgutaej3">
                <span className="h-2.5 w-2.5 rounded-full" style={{
              backgroundColor: s.color
            }} aria-hidden data-id="element-251" data-mp="1aat8joibqtf9" />
                {s.name}
              </span>
              <span className="text-right" data-id="element-252" data-mp="15d034xoui3g1">
                <span className="font-semibold text-ink" data-id="element-253" data-mp="2lnvpwls8zn0h">{formatNumber(s.value)}</span>
                <span className="ml-1.5 text-xs text-subtle" data-id="element-254" data-mp="2gqlr4fiyxyzz">{formatPercent(s.value / total)}</span>
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}